import { render, staticRenderFns } from "./PublicExpertCard.vue?vue&type=template&id=6d4eb07b&scoped=true"
import script from "./PublicExpertCard.vue?vue&type=script&lang=js"
export * from "./PublicExpertCard.vue?vue&type=script&lang=js"
import style0 from "./PublicExpertCard.vue?vue&type=style&index=0&id=6d4eb07b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4eb07b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VAvatar,VDivider,VIcon,VSheet})
